module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_tablet_349926b37d00c8b56e746843578e4ecb.webp";